import DonateComp from "../components/DonateComp";
import PageHeader from "../components/PageHeader";

const Donate = () => {
  return (
    <>
      <PageHeader />
      <DonateComp />
    </>
  );
};

export default Donate;
